module.exports = __webpack_public_path__ + "static/media/holly-michaels-lesb.79c1bae0.jpg";